import axios from 'axios';
import cookie from 'react-cookies';

export default {
  setupInterceptors: async () => {
    await axios.interceptors.request.use(async (config) => {
      if (config.url.indexOf('v1/files/') > -1) {
        config.headers['Content-Type'] = ''; // eslint-disable-line
      } else if (config.url.indexOf('v1/bulk-upload/') > 1) {
        config.headers['Content-Type'] = ''; // eslint-disable-line
      } else config.headers['Content-Type'] = 'application/json'; // eslint-disable-line
      config.headers['Access-Key'] = 'mlkjhgfdsazxcvbnmlkjhgffdsaqwrio'; // eslint-disable-line
      const token = await cookie.load('token');
      if (token) config.headers.Authorization = `Bearer ${token}`; // eslint-disable-line
      return config;
    }, (error) => {
      Promise.reject(error);
    });
    // axios.interceptors.response.use(response => response, (error) => {
    //   console.log(error, 'interceptor errorrrr');
    //   return Promise.reject(error.response);
    // });
  }
};



// WEBPACK FOOTER //
// ./src/services/Interceptors/index.js